import apiClient from './api';
import type { AnalyticsRange, Metric, StatsSummary } from './analytics.service';

/** One row of the merged "top pages" list: path, views, and the site it belongs to. */
export interface OverviewPage extends Metric {
    site: string;
}

/** GET /analytics/overview: every live site of the user, summed (dashboard "All websites"). */
export interface AnalyticsOverview {
    /** False while the server has no Umami configured. */
    enabled: boolean;
    range: AnalyticsRange;
    unit: 'hour' | 'day' | 'month';
    sites: { id: string; name: string }[];
    /** True when there is nothing to measure (no live site, or analytics disabled). */
    empty: boolean;
    timezone?: string;
    startAt?: number;
    endAt?: number;
    summary?: StatsSummary;
    previous?: StatsSummary;
    series?: { pageviews: Metric[]; sessions: Metric[] };
    leads?: { whatsapp: number; phone: number; maps: number; email: number };
    pages?: OverviewPage[];
    active?: number;
}

export const analyticsOverviewService = {
    async overview(range: AnalyticsRange, tz: string): Promise<AnalyticsOverview> {
        const res = await apiClient.get<{ success: boolean; data: AnalyticsOverview }>('/analytics/overview', { params: { range, tz } });
        return res.data.data;
    },
};

export default analyticsOverviewService;
